<template>
  <div id="dashboard">
    <v-tabs v-model="tab" color="primary">
      <v-tab>{{$t('dashboard.userInfo')}}</v-tab>
      <v-tab v-if="!isSuperAdmin">Dashboard</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-row no-gutters>
          <v-col cols="12">
            <v-card>
              <v-img max-height="280" gradient="to bottom, rgba(0, 145, 255,.6), rgba(0, 145, 255,.6)" :src="bg">
                <v-container fluid>
                  <v-row align="center" justify="start" class="white--text">
                    <v-icon class="d-block white--text" size="200px">mdi-account-box</v-icon>
                    <div class="d-block">
                      <h1 class="font-weight-regular">{{ $t('dashboard.welcome') }}</h1>
                      <h1 class="font-weight-bold">
                        {{ (userLogged.name ? userLogged.name : '') + ' ' + (userLogged.last_name ? userLogged.last_name : '') }}
                      </h1>
                    </div>
                  </v-row>
                  <v-row no-gutters align="center" justify="end">
                    <v-col class="text-right">
                      <v-btn class="primary--text" color="white" depressed @click="dialog = true">{{
                        $t('dashboard.changePassword') }}</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="mt-2">
          <v-col cols="6">
            <v-card>
              <v-card-title>
                <h3 class="title-info">{{ $t('dashboard.userInfo') }}</h3>
                <v-spacer />
                <v-btn @click="openUserDialog" small color="primary" outlined>
                  {{ $t('general.edit') }}
                </v-btn>
              </v-card-title>
              <v-divider class="mb-3" />
              <v-card-text>
                <h4 class="mb-3">
                  <span class="primary--text">{{ $t('general.name') }}:</span> {{ (userLogged.name ? userLogged.name : ' ') + ' ' + (userLogged.last_name ? userLogged.last_name : ' ') }} 
                </h4>
                <h4 class="mb-3">
                  <span class="primary--text">{{ $t('general.email') }}:</span> {{ userLogged.email ? userLogged.email : '' }}
                </h4>
                <h4 class="mb-3">
                  <span class="primary--text">{{ $t('wizard.licence_number') }}:</span> {{ userLogged.license_number ? userLogged.license_number : '-' }} 
                </h4>
                <h4 class="mb-3">
                  <span class="primary--text">{{ $t('general.role') }}:</span> {{ userLogged.roles ? userLogged.roles[0].name : '' }}
                </h4>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card>
              <v-card-title>
                <h3 class="title-info"> {{ $t('dashboard.subscription') }} </h3>
              </v-card-title>
              <v-divider class="mb-3" />
              <v-card-text>
                <h4 class="mb-3"><span class="primary--text">Plan:</span> {{ planType }} </h4>
                <h4 class="mb-3"><span class="primary--text">{{ $t('general.expirationDate') }}:</span>
                  {{ userLogged.companies[0] && userLogged.companies[0].subscription ?
                    userLogged.companies[0].subscription.expiration_date : '' }} </h4>
                <h4 class="mb-3"> {{ $t('dashboard.planMessage') }} </h4>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card>
              <v-card-title>
                <h3 class="title-info">{{ $t('dashboard.companyInfo') }}</h3>
                <v-spacer />
                <v-btn outlined color="primary" small v-if="userLogged.roles[0].id === 2" @click="openCompanyDialog">
                  {{ $t('general.edit') }}
                </v-btn>
              </v-card-title>
              <v-divider class="mb-3" />
              <v-card-text v-if="userLogged.companies">
                <h4 v-if="userLogged.companies" class="mb-3">
                  <span class="primary--text">{{ $t('general.company') }}:</span>
                  {{ userLogged.companies[0] ? userLogged.companies[0].name : '' }}
                </h4>
                <h4 class="mb-3">
                  <span class="primary--text">{{ $t('address.tax') }}:</span>
                  {{ userLogged.companies[0] ? userLogged.companies[0].tax_id : '' }}
                </h4>
                <h4 class="mb-3">
                  <span class="primary--text">{{ $t('address.social_reason') }}:</span>
                  {{ userLogged.companies[0] ? userLogged.companies[0].bussiness_name : '' }}
                </h4>
                <h4 class="mb-3">
                  <span class="primary--text">{{ $t('address.tax_regimen') }}:</span>
                  {{ userLogged.companies[0] ? userLogged.companies[0].tax_regimen : '' }}
                </h4>
                <h4 class="mb-3">
                  <span class="primary--text">{{ $t('general.phone') }}:</span>
                  {{ userLogged.companies[0] ? userLogged.companies[0].phone : ' ' }}
                </h4>
                <h4 class="mt-2 mt-5">
                  <span>{{ $t('address.name') }}</span>
                </h4>
                <v-divider class="mt-3" />
                <h4 class="mb-3 mt-2">
                  <span class="primary--text">{{ $t('address.street') }}:</span>
                  {{ userLogged.companies[0] && userLogged.companies[0].address ? userLogged.companies[0].address.street
                    : ' ' }}
                </h4>
                <h4 class="mb-3"><span class="primary--text">{{ $t('address.number') }}:</span>
                  {{ userLogged.companies[0] && userLogged.companies[0].address ?
                    userLogged.companies[0].address.street_number : ' ' }}
                </h4>
                <h4 class="mb-3"><span class="primary--text">{{ $t('address.suburb') }}:</span>
                  {{ userLogged.companies[0] && userLogged.companies[0].address ? userLogged.companies[0].address.suburb
                    : ' ' }}
                </h4>
                <h4 class="mb-3"><span class="primary--text">{{ $t('address.zip') }}:</span>
                  {{ userLogged.companies[0] && userLogged.companies[0].address ?
                    userLogged.companies[0].address.zip_code : ' ' }}
                </h4>
                <h4 class="mb-3"><span class="primary--text">{{ $t('address.city') }}:</span>
                  {{ userLogged.companies[0] && userLogged.companies[0].address ? userLogged.companies[0].address.city :
                    ' ' }}
                </h4>
                <h4 class="mb-3"><span class="primary--text">{{ $t('address.state') }}:</span>
                  {{ userLogged.companies[0] && userLogged.companies[0].address ? userLogged.companies[0].address.state
                    :
                    ' ' }}
                </h4>
                <h4 class="mb-3"><span class="primary--text">{{ $t('address.timeZone') }}:</span>
                  {{ userLogged.timezone_full && userLogged.timezone_full.label ? userLogged.timezone_full.label : ' '
                  }}
                </h4>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <!-- EDITAR USUARIO DIALOG -->
        <v-dialog width="800px" v-model="dialogUser">
          <v-card>
            <v-toolbar flat color="grey lighten-4" class="primary--text mb-4">
              {{ $t('general.editUser') }}
            </v-toolbar>
            <v-form v-model="validUser" lazy-validation ref="formUser">
              <v-container fluid>
                <v-row wrap no-gutters>
                  <v-col cols="6" class="px-4">
                    <v-text-field outlined dense :label="$t('general.name')" :rules="rules.textRules" v-model="user.name" />
                  </v-col>
                  <v-col cols="6" class="px-4">
                    <v-text-field outlined dense :label="$t('general.lastNames')" :rules="rules.textRules" v-model="user.last_name" />
                  </v-col>
                  <v-col cols="6" class="px-4">
                    <v-text-field outlined dense :label="$t('general.email')" :rules="rules.email" v-model="user.email" />
                  </v-col>
                  <v-col cols="6" class="px-4">
                    <v-text-field outlined dense :label="$t('general.phone')" :rules="rules.phoneNoRequiredRules" v-mask="'(###) ###-####'" type="tel" v-model="user.phone" />
                  </v-col>
                  <v-col cols="6" class="px-4">
                    <v-text-field outlined dense :label="$t('wizard.licence_number')" v-model="user.license_number" :rules="rules.textRulesNoRequired"/>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn color="error" depressed @click="closeUser">{{ $t('general.cancel') }}</v-btn>
              <v-btn color="primary" depressed @click="updateUser" :loading="loading" :disabled="loading">{{
                $t('general.save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog width="800px" v-model="dialogCompany">
          <v-card>
            <v-toolbar flat color="grey lighten-4" class="primary--text mb-4">
              {{ $t('general.editCompany') }}
            </v-toolbar>
            <v-form v-model="valid" lazy-validation ref="formCompany">
              <v-container fluid>
                <v-row wrap no-gutters>
                  <v-col cols="6" class="px-4">
                    <v-text-field outlined dense :label="$t('general.name')" :rules="rules.textRules"
                      v-model="company.name" />
                    <v-text-field outlined dense :label="$t('address.social_reason')" :rules="rules.textRules"
                      v-model="company.bussiness_name" />
                    <v-text-field outlined dense :label="$t('general.phone')" v-mask="'(###) ###-####'" type="tel"
                      :rules="rules.phoneRules" v-model="company.phone" />
                  </v-col>
                  <v-col cols="6" class="px-4">
                    <v-text-field outlined dense :label="$t('address.tax')" v-model="company.tax_id"
                      :rules="rules.tax" />
                    <v-autocomplete outlined dense :items="fiscal" :label="$t('address.tax_regimen')"
                      v-model="company.tax_regimen" :rules="rules.required" item-text="name" item-value="name">
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row wrap no-gutters>
                  <v-col cols="12" class="px-4">
                    <p class="font-weight-bold">{{ $t('address.name') }}</p>
                  </v-col>
                  <v-col cols="6" class="px-4">
                    <v-text-field outlined dense :label="$t('address.street')" :rules="rules.textRules"
                      v-model="company.address.street" />
                    <v-text-field outlined dense :label="$t('address.suburb')" :rules="rules.textRules"
                      v-model="company.address.suburb" />
                    <v-text-field outlined dense :label="$t('address.state')" :rules="rules.textRules"
                      v-model="company.address.state" />
                    <v-text-field outlined dense :label="$t('address.zip')" :rules="rules.textRules"
                      v-model="company.address.zip_code" />
                    <v-img v-if="file.public_url !== null" :src="file.public_url">
                    </v-img>
                  </v-col>
                  <v-col cols="6" class="px-4">
                    <v-text-field v-model="company.address.street_number" :label="$t('address.number')" :rules="rules.textRules" outlined dense/>
                    <v-text-field outlined dense :label="$t('address.city')" :rules="rules.textRules" v-model="company.address.city" />
                    <v-autocomplete outlined dense :rules="rules.required" :items="countries" item-text="name" item-value="id" :label="$t('address.country')" v-model="company.address.country_id" />
                    <v-autocomplete outlined dense :rules="rules.required" :items="timezones" item-text="label" item-value="tzCode" :label="$t('address.timeZone')" v-model="company.timezone"></v-autocomplete>
                    <vue-dropzone :key="$i18n.locale" ref="logoDropzone" id="logoDropzone" :options="dropzoneOptions"
                      v-on:vdropzone-error="fileError" v-on:vdropzone-success="fileUpload"
                      v-on:vdropzone-removed-file="removed">
                    </vue-dropzone>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn color="error" depressed @click="closeCompany">{{ $t('general.cancel') }}</v-btn>
              <v-btn color="primary" depressed @click="updateCompany" :loading="loading" :disabled="loading">{{
                $t('general.save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog width="600px" v-model="dialog">
          <v-card>
            <v-toolbar flat color="grey lighten-4" class="primary--text mb-4">
              {{ $t('dashboard.changePassword') }}
            </v-toolbar>
            <v-form v-model="valid" lazy-validation ref="form">
              <v-container fluid>
                <v-row wrap no-gutters>
                  <v-col cols="12" class="px-4">
                    <v-text-field v-model="oldPass" :label="$t('dashboard.oldPassword')" outlined dense
                      :type="viewOld ? 'text' : 'password'" :append-icon="viewOld ? 'mdi-eye-off' : 'mdi-eye'"
                      @click:append="viewOld = !viewOld" :rules="rules.required" />
                  </v-col>
                  <v-col cols="12" class="px-4">
                    <v-text-field :type="viewNew ? 'text' : 'password'" v-model="newPass"
                      :label="$t('dashboard.newPassword')" outlined dense
                      :append-icon="viewNew ? 'mdi-eye-off' : 'mdi-eye'" @click:append="viewNew = !viewNew"
                      :rules="rules.validPassword" />
                  </v-col>
                  <v-col cols="12" class="px-4">
                    <v-text-field :type="viewConfirm ? 'text' : 'password'" v-model="confirmPass"
                      :label="$t('dashboard.confirmPassword')" outlined dense
                      :append-icon="viewConfirm ? 'mdi-eye-off' : 'mdi-eye'" @click:append="viewConfirm = !viewConfirm"
                      :rules="rules.validPassword" :error-messages="errors.confirmPass" />
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn color="error" depressed @click="close">{{ $t('general.cancel') }}</v-btn>
              <v-btn color="primary" depressed @click="savePass" :loading="loading" :disabled="loading">{{
                $t('general.save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-tab-item>

      <v-tab-item v-if="!isSuperAdmin">
        <v-container fluid class="pa-6">
          <v-container fluid class="">
            <!-- FILTROS -->
            <v-row no-gutters class="mb-15-px">
              <v-col cols="12">
                <v-card outlined elevation="0" class="pa-10-px rounded-lg" style="border: 1px solid #E0E0E0;">
                  <v-row align="center" no-gutters>
                    <v-col cols="12" sm="6" md="2" class="py-2 pr-md-3">
                      <v-menu v-model="indicatorsFilters.startDateMenu" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="indicatorsFilters.start_date"
                            :error-messages="indicatorsFilters.end_date && !indicatorsFilters.start_date ? $t('validation.startDate') : ''"
                            :label="$t('general.startDate')" prepend-icon="mdi-calendar" readonly dense outlined
                            :hide-details="!indicatorsFilters.end_date || !!indicatorsFilters.start_date"
                            style="max-width: 100%;" v-bind="attrs" v-on="on">
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="indicatorsFilters.start_date" :max="indicatorsFilters.end_date"
                          @input="indicatorsFilters.startDateMenu = false" color="primary"></v-date-picker>
                      </v-menu>
                    </v-col>

                    <v-col cols="12" sm="6" md="2" class="py-2 pr-md-3">
                      <v-menu v-model="indicatorsFilters.endDateMenu" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="indicatorsFilters.end_date"
                            :error-messages="indicatorsFilters.start_date && !indicatorsFilters.end_date ? $t('validation.endDate') : ''"
                            :label="$t('general.endDate')" prepend-icon="mdi-calendar" readonly dense outlined
                            :hide-details="!indicatorsFilters.start_date || !!indicatorsFilters.end_date"
                            style="max-width: 100%;" v-bind="attrs" v-on="on">
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="indicatorsFilters.end_date" :min="indicatorsFilters.start_date" @input="indicatorsFilters.endDateMenu = false" color="primary"></v-date-picker>
                      </v-menu>
                    </v-col>

                    <v-col cols="12" sm="6" md="3" class="py-2 pr-md-3">
                      <v-select v-model="indicatorsFilters.site_id" item-text="name" item-value="id" :items="sites"
                        :label="$t('general.courtYards')" dense outlined hide-details>
                        <template v-slot:append>
                          <v-icon v-if="indicatorsFilters.site_id"
                            @click="indicatorsFilters.site_id = null">mdi-close</v-icon>
                        </template>
                      </v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="2" class="py-2 pr-md-3">
                      <v-select v-model="indicatorsFilters.user_id" :items="users" :item-text="getInspector"
                        item-value="id" label="Inspector" dense outlined hide-details>
                        <template v-slot:append>
                          <v-icon v-if="indicatorsFilters.user_id"
                            @click="indicatorsFilters.user_id = null">mdi-close</v-icon>
                        </template>
                      </v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="2" class="py-2 pr-md-3">
                      <v-select v-model="indicatorsFilters.unit_type_id" :items="unitTypes" item-text="alias"
                        item-value="id" :label="$t('general.unitType')" dense outlined hide-details>
                        <template v-slot:append>
                          <v-icon v-if="indicatorsFilters.unit_type_id"
                            @click="indicatorsFilters.unit_type_id = null">mdi-close</v-icon>
                        </template>
                      </v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="12" lg="1" class="py-2 align-center d-flex pr-md-3">
                      <v-btn @click="GetInspectionIndicators()" :disabled="areFiltersEmpty" :loading="btnDisabled" block color="primary" depressed>
                        {{ $t('reports.filter') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <!-- CARD INFORMATIVOS -->
            <v-row class="mb-6 card-row" style="margin-top:-10px !important">
              <v-col v-for="(card, index) in dashboardCards" :key="index" cols="12" sm="6" md="3" class="d-flex">
                <v-card class="dashboard-card pa-3 elevation-2 rounded-lg card-zoom-effect d-flex align-center" style="border-left: 5px solid" :style="{ borderColor: card.borderColor }">
                  <v-row align="center" no-gutters class="fill-height w-100">
                    <v-col cols="4" class="d-flex justify-center align-center">
                      <v-icon large :color="card.iconColor">{{ card.icon }}</v-icon>
                    </v-col>
                    <v-col cols="8" class="d-flex flex-column justify-center">
                      <h4 class="dashboard-card-title subtitle-1 font-weight-medium text--secondary mb-1">
                        {{ card.title }}
                      </h4>
                      <div v-if="card.loading" class="d-flex align-center">
                        <div class="custom-spinner"></div>
                      </div>
                      <h2 v-else class="dashboard-card-value text-h5 font-weight-bold mb-0">
                        {{ card.value }}
                      </h2>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
          <v-row style="margin-top:-25px !important" no-gutters>
            <v-col cols="12" md="6" class="pr-md-3">
              <v-card class="dashboard-card rounded-lg" style="min-height: 500px;">
                <v-card-title class="d-block text-h6 font-weight-bold">
                  {{ $t('inspections.count') }}
                </v-card-title>
                <v-spacer />
                <v-card-subtitle class="px-4 pt-0">
                  <div class="d-flex align-center justify-end">
                    <div class="d-flex align-center">
                      <v-menu v-model="filters.startDateMenu" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="filters.start_date" :label="$t('general.startDate')"
                            prepend-icon="mdi-calendar" readonly dense outlined hide-details style="max-width: 150px;"
                            v-bind="attrs" v-on="on">
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="filters.start_date" @input="filters.startDateMenu = false" :max="filters.end_date"
                          color="primary"></v-date-picker>
                      </v-menu>

                      <v-menu v-model="filters.endDateMenu" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="filters.end_date" :label="$t('general.endDate')"
                            prepend-icon="mdi-calendar" readonly dense outlined hide-details
                            style="max-width: 150px; margin-left: 10px;" v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="filters.end_date" @input="filters.endDateMenu = false" color="primary" :min="filters.start_date"></v-date-picker>
                      </v-menu>
                    </div>

                    <v-btn color="primary" depressed class="ml-4" @click="GetInspectionCompleted()">
                      {{ $t('reports.filter') }}
                    </v-btn>
                  </div>
                </v-card-subtitle>

                <v-divider class="mx-4 mt-2"></v-divider>

                <v-card-text class="d-flex flex-column justify-space-between" style="height: calc(100% - 120px);">
                  <div v-if="isChartLoading" class="d-flex justify-center align-center" style="height: 350px;">
                    <div class="text-center">
                      <div class="custom-spinner"></div>
                      <p class="mt-4 grey--text text--darken-1">{{ $t('general.loading') }}...</p>
                    </div>
                  </div>

                  <apexchart v-else type="line" height="350" :options="chartOptions" :series="chartSeries"></apexchart>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6" class="pl-md-3">
              <v-card class="dashboard-card rounded-lg" style="min-height: 500px;">
                <v-card-title class="d-block text-h6 font-weight-bold">
                  {{ $t('general.damageInspections') }}
                </v-card-title>
                <v-spacer />
                <v-card-subtitle class="px-4 pt-0">
                  <div class="d-flex align-center justify-end">
                    <div class="d-flex align-center">
                      <v-menu v-model="damageFilters.startDateMenu" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="damageFilters.start_date" :label="$t('general.startDate')"
                            prepend-icon="mdi-calendar" readonly dense outlined hide-details style="max-width: 150px;"
                            v-bind="attrs" v-on="on">
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="damageFilters.start_date" @input="damageFilters.startDateMenu = false" :max="damageFilters.end_date"
                          color="primary"></v-date-picker>
                      </v-menu>

                      <v-menu v-model="damageFilters.endDateMenu" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="damageFilters.end_date" :label="$t('general.endDate')"
                            prepend-icon="mdi-calendar" readonly dense outlined hide-details
                            style="max-width: 150px; margin-left: 10px;" v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="damageFilters.end_date" @input="damageFilters.endDateMenu = false" :min="damageFilters.start_date" color="primary"></v-date-picker>
                      </v-menu>
                    </div>

                    <v-btn color="primary" depressed class="ml-4" @click="GetDamageChart()">
                      {{ $t('reports.filter') }}
                    </v-btn>
                  </div>
                </v-card-subtitle>

                <v-divider class="mx-4 mt-2"></v-divider>

                <v-card-text class="d-flex flex-column justify-space-between" style="height: calc(100% - 120px);">
                  <div v-if="DamageLoading" class="d-flex justify-center align-center" style="height: 350px;">
                    <div class="text-center">
                      <div class="custom-spinner"></div>
                      <p class="mt-4 grey--text text--darken-1">{{ $t('general.loading') }}...</p>
                    </div>
                  </div>

                  <apexchart v-else ref="damageChart" type="donut" height="350" :options="damagePieChartOptions"
                    :series="damagePieSeries"></apexchart>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-6">
            <v-col cols="12" md="6" class="pr-md-3">
              <v-card class="dashboard-card rounded-lg" style="min-height: 480px;">
                <v-card-title class="d-block text-h6 font-weight-bold">
                  {{ $t('general.sitesDamage') }}
                </v-card-title>
                <v-spacer />
                <v-card-subtitle class="px-4 pt-0">
                  <div class="d-flex align-center justify-end">
                    <div class="d-flex align-center">
                      <v-menu v-model="damageByPatioFilter.startDateMenu" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="damageByPatioFilter.start_date" :label="$t('general.startDate')"
                            prepend-icon="mdi-calendar" readonly dense outlined hide-details style="max-width: 150px;"
                            v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="damageByPatioFilter.start_date" :max="damageByPatioFilter.end_date"
                          @input="damageByPatioFilter.startDateMenu = false" color="primary"></v-date-picker>
                      </v-menu>

                      <v-menu v-model="damageByPatioFilter.endDateMenu" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="damageByPatioFilter.end_date" :label="$t('general.endDate')"
                            prepend-icon="mdi-calendar" readonly dense outlined hide-details
                            style="max-width: 150px; margin-left: 10px;" v-bind="attrs" v-on="on">
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="damageByPatioFilter.end_date" :min="damageByPatioFilter.start_date" @input="damageByPatioFilter.endDateMenu = false" color="primary"></v-date-picker>
                      </v-menu>
                    </div>

                    <v-btn color="primary" depressed class="ml-4" @click="GetdamageByPatio()">
                      {{ $t('reports.filter') }}
                    </v-btn>
                  </div>
                </v-card-subtitle>

                <v-divider class="mx-4 mt-2"></v-divider>

                <v-card-text class="d-flex flex-column justify-space-between" style="height: calc(100% - 120px);">
                  <div v-if="SitesDamageLoading" class="d-flex justify-center align-center" style="height: 350px;">
                    <div class="text-center">
                      <div class="custom-spinner"></div>
                      <p class="mt-4 grey--text text--darken-1">{{ $t('general.loading') }}...</p>
                    </div>
                  </div>
                  <v-simple-table dense v-else>
                    <thead>
                      <tr>
                        <th class="text-left subtitle-2 font-weight-medium">
                          {{ $t('general.courtYards') }}
                        </th>
                        <th class="text-right subtitle-2 font-weight-medium">
                          #{{ $t('general.damage') }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="filteredTopSites.length === 0">
                        <td colspan="2" class="text-center grey--text text--darken-1">
                          {{$t('general.thereIsNoData')}}
                        </td>
                      </tr>
                      <tr v-for="(patio, index) in filteredTopSites" :key="index">
                        <td class="text-left subtitle-2 text--secondary">
                          {{ patio.name }}
                        </td>
                        <td class="text-right font-weight-bold text-h6">
                          {{ patio.total }}
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-col>
           <v-col cols="12" md="6" class="pl-md-3">

              <v-card class="dashboard-card rounded-lg mb-6" style="min-height: 500px;">
                <v-card-title class="d-block text-h6 font-weight-bold">
                  {{ $t('general.inspectionPointsDamage') }}
                </v-card-title>
                <v-spacer />
                <v-card-subtitle class="px-4 pt-0">
                  <div class="d-flex align-center justify-end">
                    <div class="d-flex align-center">
                      <v-menu v-model="inspectionPointsFilters.startDateMenu" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="inspectionPointsFilters.start_date" :label="$t('general.startDate')"
                            prepend-icon="mdi-calendar" readonly dense outlined hide-details style="max-width: 150px;"
                            v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="inspectionPointsFilters.start_date"
                          @input="inspectionPointsFilters.startDateMenu = false" :max="inspectionPointsFilters.end_date"
                          color="primary"></v-date-picker>
                      </v-menu>

                      <v-menu v-model="inspectionPointsFilters.endDateMenu" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="inspectionPointsFilters.end_date" :label="$t('general.endDate')"
                            prepend-icon="mdi-calendar" readonly dense outlined hide-details
                            style="max-width: 150px; margin-left: 10px;" v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="inspectionPointsFilters.end_date"
                          @input="inspectionPointsFilters.endDateMenu = false" :min="inspectionPointsFilters.start_date"
                          color="primary"></v-date-picker>
                      </v-menu>
                    </div>
                    <v-btn color="primary" depressed class="ml-4" @click="GetInspectionPointsChart()">
                      {{ $t('reports.filter') }}
                    </v-btn>
                  </div>
                </v-card-subtitle>

                <v-divider class="mx-4 mt-2"></v-divider>

                <v-card-text class="d-flex flex-column justify-space-between" style="height: calc(100% - 120px);">
                  <div v-if="InspectionPointsLoading" class="d-flex justify-center align-center" style="height: 350px;">
                    <div class="text-center">
                      <div class="custom-spinner"></div>
                      <p class="mt-4 grey--text text--darken-1">{{ $t('general.loading') }}...</p>
                    </div>
                  </div>
                  <apexchart v-else ref="stackedBarChart" type="bar" height="350" :options="stackedBarOptions"
                    :series="stackedBarSeries"></apexchart>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

        <v-row no-gutters class="mt-6">
            <v-col cols="12" md="6" class="pr-md-3">
              <v-card class="dashboard-card rounded-lg d-flex flex-column" style="min-height: 500px;">
                <v-card-title class="d-block text-h6 font-weight-bold mb-2">
                  {{ $t('general.damagedOperators') }}
                </v-card-title>
                <v-card-subtitle class="px-4 pt-4">
                  <div class="d-flex align-center justify-end">
                    <div class="d-flex align-center">
                      <v-menu v-model="operatorsDamageFilters.startDateMenu" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="operatorsDamageFilters.start_date" :label="$t('general.startDate')"
                            prepend-icon="mdi-calendar" readonly dense outlined hide-details style="max-width: 150px;"
                            v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="operatorsDamageFilters.start_date"
                          @input="operatorsDamageFilters.startDateMenu = false" :max="operatorsDamageFilters.end_date"
                          color="primary"></v-date-picker>
                      </v-menu>

                      <v-menu v-model="operatorsDamageFilters.endDateMenu" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="operatorsDamageFilters.end_date" :label="$t('general.endDate')"
                            prepend-icon="mdi-calendar" readonly dense outlined hide-details
                            style="max-width: 150px; margin-left: 10px;" v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="operatorsDamageFilters.end_date"
                          @input="operatorsDamageFilters.endDateMenu = false" :min="operatorsDamageFilters.start_date"
                          color="primary"></v-date-picker>
                      </v-menu>
                    </div>
                    <v-btn color="primary" depressed class="ml-4" @click="GetDamagedOperators()">
                      {{ $t('reports.filter') }}
                    </v-btn>
                  </div>
                </v-card-subtitle>

                <v-divider class="mx-4 mt-2"></v-divider>

                <v-card-text class="d-flex flex-column justify-space-between" style="height: calc(100% - 120px);">
                  <div v-if="OperatorsDamageLoading" class="d-flex justify-center align-center" style="height: 350px;">
                    <div class="text-center">
                      <div class="custom-spinner"></div>
                      <p class="mt-4 grey--text text--darken-1">{{ $t('general.loading') }}...</p>
                    </div>
                  </div>

                  <v-simple-table dense v-else>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left subtitle-2 font-weight-medium">{{ $t('general.operator') }}</th>
                          <th class="text-center subtitle-2 font-weight-medium">Total</th>
                          <th class="text-center subtitle-2 font-weight-bold blue--text text--darken-1">{{
                            $t('inspections.slight') }}</th>
                          <th class="text-center subtitle-2 font-weight-bold amber--text text--darken-2">{{
                            $t('inspections.moderate') }}</th>
                          <th class="text-center subtitle-2 font-weight-bold red--text text--darken-1">{{
                            $t('inspections.high') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="topOperators.length === 0">
                          <td colspan="5" class="text-center grey--text text--darken-1 pt-4">
                            {{ $t('general.thereIsNoData') }}
                          </td>
                        </tr>
                        <tr v-for="(op, index) in topOperators" :key="index">
                          <td class="text-left text--secondary">{{ op.name }}</td>
                          <td class="text-center font-weight-bold text--secondary">{{ op.total }}</td>
                          <td class="text-center heatmap-cell" :class="getTextColor('soft', op.soft)"
                            :style="{ backgroundColor: getHeatmapColor('soft', op.soft) }">
                            {{ op.soft }}
                          </td>
                          <td class="text-center heatmap-cell" :class="getTextColor('moderate', op.moderate)"
                            :style="{ backgroundColor: getHeatmapColor('moderate', op.moderate) }">
                            {{ op.moderate }}
                          </td>
                          <td class="text-center heatmap-cell" :class="getTextColor('hard', op.hard)"
                            :style="{ backgroundColor: getHeatmapColor('hard', op.hard) }">
                            {{ op.hard }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions class="px-4 py-3 pb-4 d-flex align-center flex-wrap">
                  <span class="text-caption font-weight-bold mr-4 text--secondary">{{ $t('general.intensityDamage')
                  }}</span>

                  <div class="d-flex align-center mr-4">
                    <span class="text-caption blue--text text--darken-1 mr-2">{{ $t('inspections.slight') }}</span>
                    <div class="heatmap-legend">
                      <div style="background-color: #E3F2FD"></div>
                      <div style="background-color: #BBDEFB"></div>
                      <div style="background-color: #64B5F6"></div>
                      <div style="background-color: #2196F3"></div>
                      <div style="background-color: #1976D2"></div>
                    </div>
                  </div>

                  <div class="d-flex align-center mr-4">
                    <span class="text-caption amber--text text--darken-2 mr-2">{{ $t('inspections.moderate') }}</span>
                    <div class="heatmap-legend">
                      <div style="background-color: #FFF8E1"></div>
                      <div style="background-color: #FFECB3"></div>
                      <div style="background-color: #FFE082"></div>
                      <div style="background-color: #FFD54F"></div>
                      <div style="background-color: #FFC107"></div>
                    </div>
                  </div>

                  <div class="d-flex align-center">
                    <span class="text-caption red--text text--darken-1 mr-2">{{ $t('inspections.high') }}</span>
                    <div class="heatmap-legend">
                      <div style="background-color: #FDECEA"></div>
                      <div style="background-color: #F8BBD0"></div>
                      <div style="background-color: #EF9A9A"></div>
                      <div style="background-color: #E57373"></div>
                      <div style="background-color: #D32F2F"></div>
                    </div>
                  </div>
                </v-card-actions>
              </v-card>
            </v-col>

            <v-col cols="12" md="6" class="pl-md-3">
              <v-card class="dashboard-card rounded-lg d-flex flex-column" style="min-height: 500px;">
                <v-card-title class="d-block text-h6 font-weight-bold mb-2">
                  {{ $t('general.frequencyOfDamagePerUnit') }}
                </v-card-title>
                <v-card-subtitle class="px-4 pt-4">
                  <div class="d-flex align-center justify-end">
                    <div class="d-flex align-center">
                      <v-menu v-model="damageFrequencyFilters.startDateMenu" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="damageFrequencyFilters.start_date" :label="$t('general.startDate')"
                            prepend-icon="mdi-calendar" readonly dense outlined hide-details style="max-width: 150px;"
                            v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="damageFrequencyFilters.start_date"
                          @input="damageFrequencyFilters.startDateMenu = false" :max="damageFrequencyFilters.end_date"
                          color="primary"></v-date-picker>
                      </v-menu>

                      <v-menu v-model="damageFrequencyFilters.endDateMenu" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="damageFrequencyFilters.end_date" :label="$t('general.endDate')"
                            prepend-icon="mdi-calendar" readonly dense outlined hide-details
                            style="max-width: 150px; margin-left: 10px;" v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="damageFrequencyFilters.end_date"
                          @input="damageFrequencyFilters.endDateMenu = false" :min="damageFrequencyFilters.start_date"
                          color="primary"></v-date-picker>
                      </v-menu>
                    </div>
                    <v-btn color="primary" depressed class="ml-4" @click="GetDamageFrequency()">
                      {{ $t('reports.filter') }}
                    </v-btn>
                  </div>
                </v-card-subtitle>

                <v-divider class="mx-4 mt-2"></v-divider>

                <v-card-text class="d-flex flex-column justify-space-between" style="height: calc(100% - 120px);">
                  <div v-if="DamageFrequencyLoading" class="d-flex justify-center align-center" style="height: 350px;">
                    <div class="text-center">
                      <div class="custom-spinner"></div>
                      <p class="mt-4 grey--text text--darken-1">{{ $t('general.loading') }}...</p>
                    </div>
                  </div>
                  <apexchart v-else ref="damageFrequencyChart" type="bar" height="350" :options="damageFrequencyOptions"
                    :series="damageFrequencySeries"></apexchart>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

        </v-container>
      </v-tab-item>

    </v-tabs-items>
  </div>
</template>

<script>
import bg from '../assets/img/bg.jpg'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {mask} from 'vue-the-mask'
import VueApexCharts from 'vue-apexcharts'
export default {
  directives: {mask},
  name: 'dashboard',
  components: {
    vueDropzone: vue2Dropzone,
    apexchart: VueApexCharts
  },
  data () {
    return {
      tab: 0,
      dashboardLoaded: false,
      loadTable: true,
      sites: [],
      unitTypes: [],
      users: [],
      filters: {
        start_date: null,
        end_date: null,
        startDateMenu: false,
        endDateMenu: false,
      },
      damageFilters: {
        start_date: null,
        end_date: null,
        startDateMenu: false,
        endDateMenu: false,
      },
      damageByPatioFilter: {
        start_date: null,
        end_date: null,
        startDateMenu: false,
        endDateMenu: false,
      },
      inspectionFilters: {
        start_date: null,
        end_date: null,
        startDateMenu: false,
        endDateMenu: false,
      },
      indicatorsFilters: {
        start_date: null,
        end_date: null,
        startDateMenu: false,
        endDateMenu: false,
        site_id: null,
        unit_type_id: null,
        user_id: null,
      },
      chartSeries: [],
      isChartLoading: false,
      DamageLoading: false,
      SitesDamageLoading: false,
      damagePieSeries: [0, 0, 0, 0],

      topSites: [],
      fiscal: [],
      company: {
        timezone: '',
        logo_id: undefined,
        name: '',
        phone: '',
        tax_regimen: '',
        tax_id: '',
        bussiness_name: '',
        address: {
          street: '',
          street_number: '',
          suburb: '',
          city: '',
          state: '',
          country_id: '',
          zip_code: ''
        }
      },
      user: {
        name: '',
        license_number: '',
        last_name: '',
        email: '',
        phone: ''
      },
      file: {
        public_url: null
      },
      taxes: [],
      countries: [],
      timezones: [],
      valid: true,
      dialog: false,
      dialogCompany: false,
      dialogUser: false,
      validUser: true,
      viewOld: false,
      viewNew: false,
      viewConfirm: false,
      loading: false,
      planType: '',
      bg: bg,
      oldPass: '',
      newPass: '',
      confirmPass: '',
      errors: {},
      defaultInfo: {
        name: '',
        last_name: '',
        email: '',
        companies: [
          {name: ''}
        ],
        roles: [
          {name: ''}
        ],
        plan: {
          subscription: {
            name: 'Plan A'
          },
          expiration_date: '2020/08/20'
        }
      },
      unitRejected: 0,
      occurredIncidence: 0,
      unitsWithHighDamage: 0,
      totalInspections: 0,
      btnDisabled: false,
      unitWithDamage: 0,
      inspectionsToday: 0,
      btnDisabled: false,
      inspectionPointsFilters: {
        start_date: null,
        end_date: null,
        startDateMenu: false,
        endDateMenu: false,
      },
      InspectionPointsLoading: false,
      stackedBarSeries: [],
      stackedBarOptions: {
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: { show: false }
        },
        noData: {
          text: this.$t('general.thereIsNoData'),
          align: 'center',
          verticalAlign: 'middle',
          style: {
            fontSize: '16px',
            color: '#9E9E9E',
            fontFamily: 'Arial, sans-serif'
          }
        },
        colors: ['#A9D0F5', '#FBE29F', '#E57373'],
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 3,
            barHeight: '75%',
            dataLabels: { total: { enabled: false } }
          },
        },
        xaxis: {
          categories: [],
          title: {
            text: this.$t('general.damage'),
            style: { color: '#8e8e8e', fontSize: '12px', fontWeight: 'normal' }
          }
        },
        yaxis: {
          labels: {
            style: { fontSize: '12px', colors: '#555' },
            minWidth: 180,
            maxWidth: 180,
            formatter: function (value) {
              if (value && typeof value === 'string' && value.length > 25) {
                return value.substring(0, 25) + '...';
              }
              return value;
            }
          }
        },
        dataLabels: {
          enabled: true,
          style: { 
            colors: ['#333'],
            fontSize: '11px',
            fontWeight: 600
          },
          dropShadow: { enabled: false },
          formatter: function (val) { return val > 0 ? val : ''; }
        },
        legend: { 
          position: 'bottom', 
          horizontalAlign: 'center', 
          markers: { radius: 2 },
          itemMargin: { horizontal: 15, vertical: 5 }
        },
        responsive: [
          {
            breakpoint: 768,
            options: {
              yaxis: {
                labels: {
                  minWidth: 100,
                  maxWidth: 100,
                  style: { fontSize: '10px' },
                  formatter: function (value) {
                    if (value && typeof value === 'string' && value.length > 15) {
                      return value.substring(0, 15) + '...';
                    }
                    return value;
                  }
                }
              },
              dataLabels: {
                style: { fontSize: '10px' }
              },
              plotOptions: {
                bar: { barHeight: '85%' }
              }
            }
          }
        ],
        tooltip: {
          custom: ({ series, seriesIndex, dataPointIndex, w }) => {
            const category = w.globals.labels[dataPointIndex] || '';
            const leve = series[0][dataPointIndex] || 0;
            const moderado = series[1][dataPointIndex] || 0;
            const alto = series[2][dataPointIndex] || 0;
            const total = leve + moderado + alto;

            return `
              <div style="font-family: Arial, sans-serif; box-shadow: 0 4px 10px rgba(0,0,0,0.15); border-radius: 6px; background: white; border: 1px solid #e0e0e0; min-width: 140px;">
                <div style="background-color: #0091FF; color: white; padding: 10px 12px; border-radius: 5px 5px 0 0; font-weight: bold; font-size: 13px; white-space: normal;">
                  ${category}
                </div>
                <div style="padding: 12px;">
                  <div style="margin-bottom: 8px; font-weight: bold; font-size: 13px; color: #333;">${this.$t('general.totalDamages')}: ${total}</div>
                  <div style="color: #666; font-size: 12px; margin-bottom: 4px;">${this.$t('general.low')}: <span style="font-weight: 500; color: #333;">${leve}</span></div>
                  <div style="color: #666; font-size: 12px; margin-bottom: 4px;">${this.$t('general.medium')}: <span style="font-weight: 500; color: #333;">${moderado}</span></div>
                  <div style="color: #666; font-size: 12px;">${this.$t('general.high')}: <span style="font-weight: 500; color: #333;">${alto}</span></div>
                </div>
              </div>
            `;
          }
        }
      },
      operatorsDamageFilters: {
        start_date: null,
        end_date: null,
        startDateMenu: false,
        endDateMenu: false,
      },
      OperatorsDamageLoading: false,
      topOperators: [],
      damageFrequencyFilters: {
        start_date: null,
        end_date: null,
        startDateMenu: false,
        endDateMenu: false,
      },
      DamageFrequencyLoading: false,
      damageFrequencySeries: [],
      damageFrequencyTooltipData: [],
      damageFrequencyOptions: {
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: { show: false }
        },
        colors: ['#0091FF', '#FFC107', '#DC3545'],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '45%',
            borderRadius: 2,
            dataLabels: {
              total: {
                enabled: true,
                style: {
                  color: '#333',
                  fontSize: '14px',
                  fontWeight: 600
                },
                formatter: (val, opts) => {
                   const index = opts.dataPointIndex;
                   const originalData = this.damageFrequencyTooltipData[index];
                   
                   if (originalData && originalData.totalDamages > 0) {
                     const proportion = val / originalData.totalDamages;
                     const newFrequency = originalData.frequency * proportion;
                     return Math.round(newFrequency) + '%';
                   }
                   
                   return originalData ? '0%' : val;
                }
              }
            }
          },
        },
        xaxis: {
          categories: [],
          title: { text: this.$t('general.units'), style: { color: '#000', fontSize: '13px', fontWeight: 'bold' } }
        },
        yaxis: {
          title: { text: this.$t('general.frequency'), style: { color: '#000', fontSize: '13px', fontWeight: 'bold' } },
          labels: { style: { fontSize: '12px', colors: '#555' } }
        },
        dataLabels: { enabled: false },
        legend: { 
          position: 'bottom', 
          horizontalAlign: 'center',
          markers: { radius: 12 }
        },
        tooltip: {
          custom: ({ series, seriesIndex, dataPointIndex, w }) => {
            const data = this.damageFrequencyTooltipData[dataPointIndex];
            if (!data) return '';
            
            const low = series[0] && series[0][dataPointIndex] !== undefined ? series[0][dataPointIndex] : 0;
            const moderate = series[1] && series[1][dataPointIndex] !== undefined ? series[1][dataPointIndex] : 0;
            const high = series[2] && series[2][dataPointIndex] !== undefined ? series[2][dataPointIndex] : 0;
            
            const totalVisible = low + moderate + high;

            const originalTotal = data.totalDamages > 0 ? data.totalDamages : 1;
            const originalDamagesPerDay = parseFloat(data.damagesPerDay) || 0;
            const dynamicDamagesPerDay = ((totalVisible / originalTotal) * originalDamagesPerDay).toFixed(1);

            return `
              <div style="font-family: Arial, sans-serif; box-shadow: 0 4px 10px rgba(0,0,0,0.15); border-radius: 6px; background: white; border: 1px solid #e0e0e0; min-width: 170px;">
                <div style="background-color: #0091FF; color: white; padding: 10px 12px; border-radius: 5px 5px 0 0; font-weight: bold; font-size: 13px;">
                  ${this.$t('monitoring.numberEconomic')}: ${data.unitNumber}<br>
                  ${this.$t('general.plate')}: ${data.plate}
                </div>
                <div style="padding: 12px; font-size: 12px;">
                  <div style="margin-bottom: 4px; color: #333;">${this.$t('general.damagesPerDay')}: <b>${dynamicDamagesPerDay}</b></div>
                  <div style="margin-bottom: 8px; color: #333;">${this.$t('general.totalDamages')}: <b>${totalVisible}</b></div>
                  <div style="color: #666; margin-bottom: 2px;">${this.$t('inspections.slight')}: <span style="font-weight: 500; color: #333;">${low}</span></div>
                  <div style="color: #666; margin-bottom: 2px;">${this.$t('general.medium')}: <span style="font-weight: 500; color: #333;">${moderate}</span></div>
                  <div style="color: #666;">${this.$t('general.high')}: <span style="font-weight: 500; color: #333;">${high}</span></div>
                </div>
              </div>
            `;
          }
        }
      },
    }
  },
  watch: {
    userLogged: {
      immediate: true,
      handler(user) {
        if (!user || !user.roles || !user.roles[0] || !user.roles[0].id) return;

        if (user.roles[0].id === 1) return;

        this.tab = 1;

        if (!this.dashboardLoaded) {
          this.loadDashboardData();
          this.dashboardLoaded = true;
        }
      }
    },
    confirmPass () {
      if (this.newPass !== this.confirmPass) {
        this.errors.confirmPass = this.$t('dashboard.passNoMatch')
      } else {
        this.errors.confirmPass = ''
      }
    },
    newPass () {
      if (this.newPass !== this.confirmPass) {
        this.errors.confirmPass = this.$t('dashboard.passNoMatch')
      } else {
        this.errors.confirmPass = ''
      }
    },
    '$i18n.locale'() {
      let labels = this.damagePieChartOptions.labels[0] === 'Sin datos' || this.damagePieChartOptions.labels[0] === this.$t('general.thereIsNoData')
        ? [this.$t('general.thereIsNoData')]
        : [this.$t('general.accepted'), this.$t('general.low'), this.$t('general.medium'), this.$t('general.high')];

      if (this.$refs.damageChart) {
        this.$refs.damageChart.updateOptions({
          labels: labels,
          chart: {
            noData: { text: this.$t('general.thereIsNoData') }
          }
        });
      }

      if (this.stackedBarSeries && this.stackedBarSeries.length === 3) {
        this.stackedBarSeries[0].name = this.$t('general.low');
        this.stackedBarSeries[1].name = this.$t('general.medium');
        this.stackedBarSeries[2].name = this.$t('general.high');
      }

      if (this.$refs.stackedBarChart) {
        this.$refs.stackedBarChart.updateSeries(this.stackedBarSeries);
        this.$refs.stackedBarChart.updateOptions({
          xaxis: {
            title: { text: this.$t('general.damage') }
          },
          noData: {
            text: this.$t('general.thereIsNoData')
          }
        });
      }

      if (this.damageFrequencySeries && this.damageFrequencySeries.length === 3) {
        this.damageFrequencySeries[0].name = this.$t('inspections.slight');
        this.damageFrequencySeries[1].name = this.$t('general.medium');
        this.damageFrequencySeries[2].name = this.$t('general.high');
      }

      if (this.$refs.damageFrequencyChart) {
        this.$refs.damageFrequencyChart.updateSeries(this.damageFrequencySeries);
        
        this.$refs.damageFrequencyChart.updateOptions({
          xaxis: {
            title: { text: this.$t('general.units') }
          },
          yaxis: {
            title: { text: this.$t('general.frequency') }
          }
        });
      }
    }
  },
  created() {
    this.$store.dispatch('getCountry', { event: { context: this } });
    this.$store.dispatch('getFiscal', { event: { context: this } });
    this.$store.dispatch('getTimeZone', { event: { context: this, item: { perPage: -1, page: 1, ord: 'asc' } } });
  },
  computed: {
    isSuperAdmin() {
      const roles = this.userLogged && this.userLogged.roles ? this.userLogged.roles : [];
      return roles.length > 0 && roles[0].id === 1;
    },
    chartOptions() {
      return {
        chart: {
          type: "line",
          height: 350,
          zoom: { enabled: true },
          toolbar: { 
            show: true,
            tools: {
              download: true
            },
            export: {
              csv: { 
                filename: this.$t('dashboard.inspectionPerformedReport', {starDate: this.filters.start_date, endDate: this.filters.end_date}), 
                columnDelimiter: ',',
                headerCategory: this.$t('general.date'),
                headerValue: this.$t('general.inspections')
              },
              svg: { 
                filename: this.$t('dashboard.inspectionPerformedReport', {starDate: this.filters.start_date, endDate: this.filters.end_date}), 
              },
              png: { 
                filename: this.$t('dashboard.inspectionPerformedReport', {starDate: this.filters.start_date, endDate: this.filters.end_date}),
              },
            }
          },
        },
        noData: {
          text: this.$t('general.thereIsNoData'),
          align: 'center',
          verticalAlign: 'middle',
          style: {
            fontSize: '16px',
            color: '#9E9E9E',
            fontFamily: 'Arial, sans-serif'
          }
        },
        colors: ['#007BFF', '#77CFD9', '#0378A6', '#0388A6', '#55C1D9', '#03588C'],
        dataLabels: { enabled: false },
        stroke: { curve: "smooth", width: 3 },
        xaxis: {
          title: { text: this.$t('general.date') },
          labels: {
            formatter: function (value) {
              const date = new Date(value);
              const day = String(date.getDate()).padStart(2, "0");
              const month = String(date.getMonth() + 1).padStart(2, "0");
              const year = date.getFullYear();
              return `${day}-${month}-${year}`;
            },
          },
        },
        yaxis: {
          title: { text: this.$t('general.inspections') }, //AQUÍ
          min: 0,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        }
      }
    },
    damagePieChartOptions (){
      return {
        chart: {
          type: 'donut',
          height: 350,
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              resetZoom: true
            }
          },
          noData: {
            text: this.$t('general.thereIsNoData'),
            align: 'center',
            verticalAlign: 'middle',
            style: {
              fontSize: '16px',
              color: '#9E9E9E',
              fontFamily: 'Arial, sans-serif'
            }
          }
        },
        tooltip: {
          enabled: false,
        },
        dataLabels: {
          enabled: true,
          formatter: function () {
            return 0;
          }
        },
        legend: {
          show: true,
          position: 'bottom',
          formatter: function (seriesName) {
            return seriesName;
          }
        },
        colors: ['#D3D3D3'],
        labels: [this.$t('general.withoutData')],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: 'bottom',
              },
            }
          },
        ],
      }
    },
    dropzoneOptions(){
      return {
        url: process.env.VUE_APP_HOST + 'file',
        dictDefaultMessage: `<p>Logo</p>
          <h1 class="text-center"><i class="fas fa-cloud-upload-alt"></i></h1>
          <span class="text-center mb-0">${this.$t('dropzone.default', { size: '15', unit: 'MB' })}</span>
          <p class="text-center">${this.$t('general.imgFormats')}</p>`,
        dictResponseError: this.$t('dropzone.responseError'),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        uploadMultiple: false,
        addRemoveLinks: true,
        maxFilesize: 15,
        acceptedFiles: '.jpg,.png,.jpeg',
        maxFiles: 1,
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.userState.access_token,
          'X-localization': this.lang
        },
        paramName: 'ignored', // puede ser cualquiera, se eliminará
        init: function() {
          this.on('sending', function(file, xhr) {
            // 🔥 reemplazamos el FormData por uno totalmente nuevo
            const newFormData = new FormData();

            // Estructura correcta para el backend
            newFormData.append('files[0][is_public]', 1);
            newFormData.append('files[0][path]', file);

            // Sobrescribimos el FormData interno que Dropzone va a usar
            xhr.send = function() {
              // forzamos el envío usando nuestro propio formData
              XMLHttpRequest.prototype.send.call(this, newFormData);
            };
          });
        }
      }
    },
    filteredTopSites() {
      return this.topSites.filter(patio => patio.total > 0);
    },
    areFiltersEmpty() {
      const { start_date, end_date, site_id, user_id, unit_type_id } = this.indicatorsFilters;
      return !start_date && !end_date && !site_id && !user_id && !unit_type_id;
    },
    userLogged () {
      if (this.$store.state.userLogged.companies) {
        if (this.$store.state.userLogged.companies[0]) {
          this.planType = this.$store.state.userLogged.companies[0].subscription.plan_id === 1 ? 'Limitado' : 'Ilimitado'
        }
        return this.$store.state.userLogged
      } else {
        return this.defaultInfo
      }
    },
    rules () {
      return this.$validationRules()
    },
    dashboardCards () {
      return [
        {
          title: this.$t('unit.rejected'),
          value: this.unitRejected,
          icon: 'mdi-car-off',
          iconColor: '#007BFF',
          borderColor: '#007BFF',
          loading: false
        },
        {
          title: this.$t('general.occurredIncidence'),
          value: this.occurredIncidence,
          icon: 'mdi-alert-circle',
          iconColor: '#FFC107',
          borderColor: '#FFC107',
          loading: false
        },
        {
          title: this.$t('inspections.unitsWithHighDamage'),
          value: this.unitsWithHighDamage,
          icon: 'mdi-car-cog',
          iconColor: '#DC3545',
          borderColor: '#DC3545',
          loading: false
        },
        {
          title: this.$t('inspections.totalInspections'),
          value: this.totalInspections,
          icon: 'mdi-file-document-check',
          iconColor: '#28A745',
          borderColor: '#28A745',
          loading: false
        }
      ]
    },
    maxDamageValues() {
    if (!this.topOperators || this.topOperators.length === 0) {
      return { soft: 0, moderate: 0, hard: 0 };
    }
    return {
      soft: Math.max(...this.topOperators.map(op => op.soft)),
      moderate: Math.max(...this.topOperators.map(op => op.moderate)),
      hard: Math.max(...this.topOperators.map(op => op.hard)),
    };
  },
  },
  methods: {
    validateDates(filterObj) {
      if (!filterObj.start_date || !filterObj.end_date) {
        const defaults = this.loadDefaultDates();
        this.$set(filterObj, 'start_date', defaults.start_date);
        this.$set(filterObj, 'end_date', defaults.end_date);
      }
    },
    loadDashboardData() {
      this.GetInspectionIndicators();
      this.GetInspectionCompleted();
      this.GetDamageChart();
      this.GetdamageByPatio();
      this.GetInspectionPointsChart();
      this.GetDamagedOperators();
      this.GetDamageFrequency();
      
      this.$store.dispatch('sites/get', { event: { context: this, all: true, item: { perPage: -1, page: 1 } } });
      this.$store.dispatch('unitTypes/getAll', { event: { context: this } });
      this.$store.dispatch('users/getInspect', { event: { context: this, item: { perPage: -1, page: 1 } } });
    },
    loadDefaultDates() {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth();
      const day = today.getDate();

      const firstDay = new Date(year, month, 1).toISOString().substr(0, 10);

      const lastDay = new Date(year, month, day).toISOString().substr(0, 10);

      return { start_date: firstDay, end_date: lastDay };
    },
    initializeDefaultDates(filters) {
      const defaultDates = this.loadDefaultDates();
      filters.start_date = defaultDates.start_date;
      filters.end_date = defaultDates.end_date;
    },
    GetInspectionCompleted() {
      this.isChartLoading = true;
      this.validateDates(this.filters);
      this.$store
        .dispatch("inspections/getInspectionLineData", {
          event: {
            filter: {
              start_date: this.filters.start_date,
              end_date: this.filters.end_date,
            },
            context: this,
          },
        })
        .then(() => {
          this.chartSeries = this.$store.state.inspections.inspectionLineSeries || []
        })
        .finally(() => {
          this.isChartLoading = false;
        });
    },
    GetDamageChart() {
      this.DamageLoading = true;
      this.validateDates(this.damageFilters);
      this.$store.dispatch("inspections/getDamagePercentage", {
        event: {
          start_date: this.damageFilters.start_date,
          end_date: this.damageFilters.end_date,
          context: this,
        },
      });
    },
    GetdamageByPatio() {
      this.SitesDamageLoading = true;
      this.validateDates(this.damageByPatioFilter);
      this.$store.dispatch("inspections/getTopSites", {
        event: {
          start_date: this.damageByPatioFilter.start_date,
          end_date: this.damageByPatioFilter.end_date,
          context: this,
        },
      });
    },
    getMonthName(month) {
      const months = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ];
      return months[month - 1] || '';
    },
    GetInspectionIndicators() {
      this.btnDisabled = true
      this.dashboardCards.forEach(card => card.loading = true)
      this.validateDates(this.indicatorsFilters);

      this.$store.dispatch('inspections/getInspectionIndicators', {
        event: {
          filter: {
            start_date: this.indicatorsFilters.start_date,
            end_date: this.indicatorsFilters.end_date,
            site_id: this.indicatorsFilters.site_id,
            unit_type_id: this.indicatorsFilters.unit_type_id,
            user_id: this.indicatorsFilters.user_id
          }
        }
      }).then(() => {
        const indicators = this.$store.state.inspections.inspectionIndicators || {};
        const totalIncidents = (indicators.soft || 0) + (indicators.moderate || 0) + (indicators.hard || 0);
        const totalDamages = (indicators.units_hard || 0)

        this.unitRejected = indicators.units_rejected || 0
        this.occurredIncidence = totalIncidents
        this.unitsWithHighDamage = totalDamages
        this.totalInspections = indicators.inspections_total || 0
        this.dashboardCards.forEach(card => card.loading = false)
        this.btnDisabled = false
      });
    },
    getInspector(user) {
      return `${user.name} ${user.last_name}`;
    },
    clearDates() {
      this.indicatorsFilters.start_date = null;
      this.indicatorsFilters.end_date = null;
    },
    fileUpload (file, response) {
      this.company.logo_id = response.data[0].id
      this.showNotification(this.$t('dropzone.logoSuccess'), 'success')
    },
    fileError (file, message) {
      this.showNotification(message, 'error')
    },
    removed () {
      this.company.logo_id = undefined
    },
    close () {
      this.dialog = false
      this.loading = false
      this.oldPass = ''
      this.newPass = ''
      this.confirmPass = ''
      this.$refs.form.resetValidation()
    },
    closeCompany () {
      this.dialogCompany = false
      this.$refs.formCompany.resetValidation()
      this.$refs.logoDropzone.removeAllFiles()
    },
    closeUser () {
      this.dialogUser = false
      this.$refs.formUser.resetValidation()
    },
    savePass () {
      if (this.newPass === this.confirmPass) {
        if (this.$refs.form.validate()) {
          this.loading = true
          this.$store.dispatch('changePassword', {
            event: {
              item: {
                oldPassword: this.oldPass,
                newPassword: this.newPass,
                confirmPassword: this.confirmPass
              } ,context: this
            }
          })
        }
      }
    },
    getUserLogged () {
      this.$store.dispatch('userLogged', {event: {context: this}})
    },
    openCompanyDialog () {
      if (this.userLogged.companies[0].logo_id) {
        this.$store.dispatch('getFile', {
          event: {
            context: this,
            id: this.userLogged.companies[0].logo_id
          }
        })
      }
      this.company = JSON.parse(JSON.stringify(this.userLogged.companies[0]))
      this.dialogCompany = true
    },
    updateCompany () {
      if(!this.$refs.formCompany.validate()) return

      if(this.company.logo_id === null)  this.company.logo_id = undefined
      
      this.$store.dispatch('company/updateOwn', {
        event: {
          context: this,
          company: this.company
        }
      })
      this.loading = true
    },
    updateUser () {
      if(!this.$refs.formUser.validate()) return this.showNotification(this.$t('validation.errorData'), 'error')

      if (this.$refs.formUser.validate()) {
        this.$store.dispatch('users/updateOwn', {
          event: {
            context: this,
            user: this.user
          }
        })
        this.loading = true
      }
    },
    openUserDialog () {
      this.dialogUser = true
      this.user.name = this.userLogged.name
      this.user.last_name = this.userLogged.last_name
      this.user.phone = this.userLogged.phone
      this.user.license_number = this.userLogged.license_number
      this.user.email = this.userLogged.email
    },
    GetInspectionPointsChart() {
      this.InspectionPointsLoading = true;
      this.validateDates(this.inspectionPointsFilters);

      this.$store.dispatch('inspections/getInspectionPointsDamaged', {
        event: {
          start_date: this.inspectionPointsFilters.start_date,
          end_date: this.inspectionPointsFilters.end_date,
          context: this
        }
      });
    },
    GetDamagedOperators() {
      this.OperatorsDamageLoading = true;
      this.validateDates(this.operatorsDamageFilters);

      this.$store.dispatch('inspections/getOperatorCountDamaged', {
        event: {
          start_date: this.operatorsDamageFilters.start_date,
          end_date: this.operatorsDamageFilters.end_date,
          context: this
        }
      });
    },
    getHeatmapColor(severity, value) {
      if (value === 0) return '#FFFFFF'; 

      const max = this.maxDamageValues[severity];
      if (max === 0) return '#FFFFFF';

      const intensity = value / max;

      if (severity === 'soft') {
        if (intensity <= 0.2) return '#E3F2FD';
        if (intensity <= 0.4) return '#BBDEFB';
        if (intensity <= 0.6) return '#64B5F6';
        if (intensity <= 0.8) return '#2196F3';
        return '#1976D2';
      }
      if (severity === 'moderate') {
        if (intensity <= 0.2) return '#FFF8E1';
        if (intensity <= 0.4) return '#FFECB3';
        if (intensity <= 0.6) return '#FFE082';
        if (intensity <= 0.8) return '#FFD54F';
        return '#FFC107';
      }
      if (severity === 'hard') {
        if (intensity <= 0.2) return '#FDECEA';
        if (intensity <= 0.4) return '#F8BBD0';
        if (intensity <= 0.6) return '#EF9A9A';
        if (intensity <= 0.8) return '#E57373';
        return '#D32F2F';
      }
      return '#FFFFFF';
    },
    getTextColor(severity, value) {
      const max = this.maxDamageValues[severity];
      if (max === 0 || value === 0) return 'text--secondary';
      const intensity = value / max;

      if (intensity > 0.6) return 'white--text';
      return 'text--secondary';
    },
    GetDamageFrequency() {
      this.DamageFrequencyLoading = true;
      this.validateDates(this.damageFrequencyFilters);

      this.$store.dispatch('inspections/getDamageFrequencyByUnit', {
        event: {
          start_date: this.damageFrequencyFilters.start_date,
          end_date: this.damageFrequencyFilters.end_date,
          context: this
        }
      }).catch(() => {
        this.DamageFrequencyLoading = false;
      });
    },
  }
}
</script>

<style scoped>
  #logoDropzone{
    margin-top: 0px !important;
    border: 1px solid #9E9E9E !important;
    border-radius: 5px;
    padding: 10px;
    color: #665 !important;
  }

  .title-info {
    font-size: 16px !important;
    color: rgba(0, 0, 0, 0.6);
  }

  .rounded-lg {
    border-radius: 12px !important;
  }
  
  .subtitle-1 {
    font-size: 0.875rem !important;
  }
  
  .text-h5 {
    font-size: 1.25rem !important;
  }
  
  .v-card__title {
    font-weight: bold;
    padding: 16px !important;
  }
  
  .v-card__text {
    padding: 16px !important;
  }

  .card-zoom-effect {
    transition: transform 0.2s ease-in-out;
    will-change: transform;
  }
  
  .card-zoom-effect:hover {
    transform: scale(1.03);
    z-index: 1;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  }

  .v-card {
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .dashboard-card {
    min-height: 480px;
    width: 100%;
    min-height: 80px;
    height: 100%;
  }

  .mb-6 {
  margin-bottom: 24px;
  }

  .custom-spinner {
    display: inline-block;
    width: 40px;
    height: 40px;
    border: 4px solid rgba(0, 145, 255, 0.2);
    border-top-color: #0091FF;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .loading-container {
    background: rgba(255, 255, 255, 0.8);
    border-radius: 10px;
  }
  
  .v-menu__content {
    z-index: 9999 !important;
  }

  .mb-15-px {
    margin-bottom: 15px !important;
  }

  .pa-10-px {
    padding: 10px !important;
  }

  .card-row .v-col {
    margin-bottom: 5px;
    margin-top: 0px !important;
  }

  .dashboard-card-title {
    line-height: 1.3;
    word-break: break-word;
  }

  .dashboard-card-value {
    line-height: 1;
  }
  
  .heatmap-cell {
    border: 2px solid white;
    transition: background-color 0.3s ease;
  }

  .heatmap-legend {
    display: flex;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #E0E0E0;
  }

  .heatmap-legend div {
    width: 15px;
    height: 12px;
  }
</style>